import React from 'react';
import type { UserProfile, Group } from '../../types';
import type { User } from 'firebase/auth';

interface GroupMembersListProps {
    memberProfiles: UserProfile[];
    group: Group;
    currentUser: User | null | undefined;
}

export const GroupMembersList: React.FC<GroupMembersListProps> = ({
    memberProfiles,
    group,
    currentUser
}) => {
    return (
        <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
            <h3 className="text-lg font-bold text-text-heading">Members ({group.members.length})</h3>
            <div className="grid gap-3">
                {memberProfiles.map((profile) => (
                    <div key={profile.uid} className="flex items-center gap-3 rounded-xl border border-border-default bg-bg-card p-3 shadow-sm">
                        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold">
                            {profile.displayName.charAt(0).toUpperCase() || '?'}
                        </div>
                        <div>
                            <p className="text-sm font-bold text-text-heading">
                                {profile.displayName} {profile.uid === currentUser?.uid && "(You)"}
                            </p>
                            <p className="text-xs text-text-muted">
                                {profile.isAnonymous ? "Guest Member" : "Secured Account"}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
